export default __webpack_public_path__ + "static/media/menu.9cb07b3f.svg";